import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { Navigation } from 'swiper/modules';



const Slide4 = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [currentVideoID, setCurrentVideoID] = useState(null);
    const [test, setTest] = useState("");

    const openModal = (videoID) => {
        setCurrentVideoID(videoID);
        setModalOpen(true);
        document.removeEventListener("mousemove", parallax);

    };

    const closeModal = (e) => {
        setCurrentVideoID(null);
        setModalOpen(false);
        setTest(e)
    };

    const parallax = (e) => {
        const main = document.getElementById('swiperAnim');
        const rect = main.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const deltaX = e.clientX - centerX;
        const deltaY = e.clientY - centerY;
        const perspective = 2000;
        const translateX = deltaX * 0.1;
        const translateY = deltaY * 0.1;
        const translateZ = 0; // Ajout de la translation Z
        const rotateX = -deltaY * 0.02;
        const rotateY = deltaX * 0.01;

        main.style.transform = `perspective(${perspective}px) translate3d(${translateX}px, ${translateY}px, ${translateZ}px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    };

    useEffect(() => {


        document.addEventListener("mousemove", parallax);

        // Nettoyer l'écouteur d'événements lorsque le composant est démonté
        return () => {
            document.removeEventListener("mousemove", parallax);
        };

    }, [test]);

    return (
        <div className="slide4Cont">

            <img className="slide4BackgroundImage" src="../../../images/vitrine/slide4/topBackground.png" />

            {modalOpen && (
                <div className="youtubeModal" onClick={closeModal}>
                    <div className="youtubeModal-content">
                        <button className="youtubeModalclose" onClick={closeModal}>Retour</button>
                        {/* Insérez ici votre lecteur YouTube avec le videoID */}
                        {currentVideoID && (
                            <iframe
                                width="560"
                                height="315"
                                src={`https://www.youtube.com/embed/${currentVideoID}`}
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen="true"
                            ></iframe>
                        )}
                    </div>
                </div>
            )}


            <div className="testSwip" id="swiperAnim" >
                <img className="leftborder" src="../../../images/vitrine/slide4/cadre.png" width="700px" />
                <img className="rightborder" src="../../../images/vitrine/slide4/cadre.png" width="700px" />

                <button id="leftarrow" className="leftarrow" > <img src="../../../images/vitrine/slide4/arrow2.png" width="700px" /></button>

                <button id="rightarrow" className="rightarrow" > <img src="../../../images/vitrine/slide4/arrow2.png" width="700px" /></button>


                <Swiper
                    effect={'coverflow'}
                    grabCursor={false}
                    centeredSlides={true}
                    slidesPerView={'auto'}
                    coverflowEffect={{
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        modifier: 1,
                        slideShadows: false,
                    }}
                    pagination={true}
                    modules={[Navigation]}
                    className="slide4Swiper"
                    speed={1000}
                    navigation={{
                        prevEl: '#leftarrow',
                        nextEl: '#rightarrow'
                    }}
                    allowTouchMove={false}
                    loop={true}

                >

                    <SwiperSlide>
                        <div className="main" >

                            <div className="miniature" onClick={() => openModal('zk-DomYumhE?si=XfsG0j3NXYO5Huer')} >
                                <img src="../../../images/vitrine/slide4/swipper1.webp" width="640px" />
                            </div>
                            <div className="btn">
                                <svg
                                    height="512px"
                                    width="512px"
                                    viewBox="0 0 512 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                >
                                    <g id="_x33_95-youtube">
                                        <g>
                                            <path
                                                d="M476.387,144.888c-5.291-19.919-20.878-35.608-40.67-40.933C399.845,94.282,256,94.282,256,94.282s-143.845,0-179.719,9.674c-19.791,5.325-35.378,21.013-40.668,40.933c-9.612,36.105-9.612,111.438-9.612,111.438s0,75.334,9.612,111.438c5.29,19.92,20.877,34.955,40.668,40.281C112.155,417.719,256,417.719,256,417.719s143.845,0,179.717-9.674c19.792-5.326,35.379-20.361,40.67-40.281c9.612-36.104,9.612-111.438,9.612-111.438S485.999,180.994,476.387,144.888z"
                                                fill="#FF0000"
                                            />
                                            <polygon points="208.954,324.723 208.954,187.93 329.18,256.328" fill="#FFFFFF" />
                                        </g>
                                    </g>
                                    <g id="Layer_1" />
                                </svg>
                            </div>
                            <a className="Slide4Name">
                                F.C.U. Task Force
                            </a>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="main" >

                            <div className="miniature" onClick={() => openModal('cN8xJQWkqRk?si=povI2mwhZAWhIcPC')} >
                                <img src="../../../images/vitrine/slide4/swipper2.webp" width="640px" />
                            </div>
                            <div className="btn">
                                <svg
                                    height="512px"
                                    width="512px"
                                    viewBox="0 0 512 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                >
                                    <g id="_x33_95-youtube">
                                        <g>
                                            <path
                                                d="M476.387,144.888c-5.291-19.919-20.878-35.608-40.67-40.933C399.845,94.282,256,94.282,256,94.282s-143.845,0-179.719,9.674c-19.791,5.325-35.378,21.013-40.668,40.933c-9.612,36.105-9.612,111.438-9.612,111.438s0,75.334,9.612,111.438c5.29,19.92,20.877,34.955,40.668,40.281C112.155,417.719,256,417.719,256,417.719s143.845,0,179.717-9.674c19.792-5.326,35.379-20.361,40.67-40.281c9.612-36.104,9.612-111.438,9.612-111.438S485.999,180.994,476.387,144.888z"
                                                fill="#FF0000"
                                            />
                                            <polygon points="208.954,324.723 208.954,187.93 329.18,256.328" fill="#FFFFFF" />
                                        </g>
                                    </g>
                                    <g id="Layer_1" />
                                </svg>
                            </div>
                            <a className="Slide4Name">
                                Sandstorm
                            </a>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="main" >

                            <div className="miniature" onClick={() => openModal('o_tFzswTLbo?si=shQmfMhgy_LFWQER')} >
                                <img src="../../../images/vitrine/slide4/swipper3.webp" width="640px" />
                            </div>
                            <div className="btn">
                                <svg
                                    height="512px"
                                    width="512px"
                                    viewBox="0 0 512 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                >
                                    <g id="_x33_95-youtube">
                                        <g>
                                            <path
                                                d="M476.387,144.888c-5.291-19.919-20.878-35.608-40.67-40.933C399.845,94.282,256,94.282,256,94.282s-143.845,0-179.719,9.674c-19.791,5.325-35.378,21.013-40.668,40.933c-9.612,36.105-9.612,111.438-9.612,111.438s0,75.334,9.612,111.438c5.29,19.92,20.877,34.955,40.668,40.281C112.155,417.719,256,417.719,256,417.719s143.845,0,179.717-9.674c19.792-5.326,35.379-20.361,40.67-40.281c9.612-36.104,9.612-111.438,9.612-111.438S485.999,180.994,476.387,144.888z"
                                                fill="#FF0000"
                                            />
                                            <polygon points="208.954,324.723 208.954,187.93 329.18,256.328" fill="#FFFFFF" />
                                        </g>
                                    </g>
                                    <g id="Layer_1" />
                                </svg>
                            </div>
                            <a className="Slide4Name">
                                Shamrock
                            </a>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="main" >

                            <div className="miniature" >
                                <img src="../../../images/vitrine/slide4/swipper4.webp" width="640px" />
                            </div>

                            <a className="Slide4Name">
                                Soon TM
                            </a>
                        </div>
                    </SwiperSlide>



                </Swiper>
            </div>
        </div >
    );
};

export default Slide4;
